import React from "react"

const ProgressBar = ({ skillName, percentage, bgColor }) => {
  return (
    <div className="mb-2">
      <label className="text-uppercase">{skillName}</label>
      <div className="progress shadow-sm">
        <div
          className={`progress-bar progress-bar-striped progress-bar-animated ${bgColor}`}
          role="progressbar"
          aria-valuenow={percentage}
          aria-valuemin="0"
          aria-valuemax="100"
          style={{ width: percentage + "%" }}>
          {percentage + "%"}
        </div>
      </div>
    </div>
  )
}

export default ProgressBar
